import React, { useState } from 'react';
import { Upload, X, CheckCheck } from 'lucide-react';

const ProofModal = ({ onClose, onSubmit }) => {

  const [files, setFiles] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleFiles = e => {
    const picked = Array.from(e.target.files).map(f => ({
      file: f,
      url: URL.createObjectURL(f),
      type: f.type.startsWith('video') ? 'video' : 'image',
    }));
    setFiles(p => [...p, ...picked]);
  };

  const submit = () => {
    if (!files.length) return;
    setLoading(true);
    setTimeout(() => { setLoading(false); onSubmit(files); }, 1200);
  };

  return (
    <div className="aj-modal-overlay" onClick={onClose}>
      <div className="aj-modal aj-proof-modal" onClick={e => e.stopPropagation()}>
        <button className="aj-modal__close" onClick={onClose}><X size={18} /></button>
        <h3 className="aj-modal__title">Upload Proof of Work</h3>
        <p className="aj-modal__sub">Upload photo/video of completed work to mark job as done.</p>
        {files.length > 0 && (
          <div className="aj-proof-preview-row">
            {files.map((f, i) => (
              <div key={i} className="aj-media-thumb" style={{ position: 'relative' }}>
                {f.type === 'video'
                  ? <video src={f.url} className="aj-media-thumb__img" />
                  : <img src={f.url} alt="" className="aj-media-thumb__img" />}
                <button className="aj-proof-thumb-del" onClick={() => setFiles(p => p.filter((_, x) => x !== i))}><X size={11} /></button>
              </div>
            ))}
          </div>
        )}
        <label className="aj-upload-area" style={{ cursor: 'pointer' }}>
          <Upload size={22} />
          <span>Tap to add photo / video</span>
          <span className="aj-upload-area__hint">JPG, PNG, MP4, MOV</span>
          <input type="file" accept="image/*,video/*" multiple style={{ display: 'none' }} onChange={handleFiles} />
        </label>
        <button
          className={'aj-modal__submit' + (loading ? ' aj-modal__submit--loading' : '')}
          disabled={!files.length || loading}
          onClick={submit}
        >
          {loading ? <><span className="aj-spinner" /> Uploading...</> : <><CheckCheck size={15} /> Mark as Completed</>}
        </button>
      </div>
    </div>
  );
};

export default ProofModal;